/**
 * 广告反屏蔽类
 * 修改广告请求url
 * **/

import sdkTool from "If_AdTool/common/sdkTool";
import Base64 from "If_AdTool/common/Base64";
import JsLoader from "If_AdTool/common/JsLoader";
import adData from "./adModel";
let adBolckCore ={
    isBlock:false,
    loadErrorNum:0,
    pArr:["GZHGXDs","J2Bc","jWtgT","FA0","Pxlv2L"],
    dArr: ["qcvf.ifeng.com","ztyumn.ifeng.com"],
    // 运营商:默认 域名:jiejg.ifeng.com CNAME:iis1.deliver.ifeng.com.
    // 运营商:默认 域名:rugncn.ifeng.com CNAME:iis1.deliver.ifeng.com.
    // 运营商:默认 域名:snbnhngl.ifeng.com CNAME:iis1.deliver.ifeng.com.
    // 运营商:默认 域名:bvakl.ifeng.com CNAME:iis1.deliver.ifeng.com.
    // 运营商:默认 域名:cdgfa.ifeng.com CNAME:iis1.deliver.ifeng.com.
    // 运营商:默认 域名:qcvf.ifeng.com CNAME:iis1.deliver.ifeng.com.
    // 运营商:默认 域名:ztyumn.ifeng.com CNAME:iis1.deliver.ifeng.com.
    // 运营商:默认 域名:rfvkp.ifeng.com CNAME:iis1.deliver.ifeng.com.
    // 运营商:默认 域名:qwty.ifeng.com CNAME:iis1.deliver.ifeng.com.
    urlHandler:function (url) {
        let tUrl = url;
        if(this.isBlock&&window.location.href.indexOf("###DEBUG")==-1){
            tUrl =url;
            let path =  url.substr(0,url.indexOf("?"));
            let search =  url.substr(url.indexOf("?")+1);
            search = this.randomSearch(search);
            console.log(search);
            let domain = this.dArr[Math.floor(this.dArr.length*Math.random())];
            let dPath = this.pArr[Math.floor(this.pArr.length*Math.random())];
            path = path.replace(adData.ADX_DOMAIN, domain);
            path = path.replace(adData.ADX_PATH, dPath);
            search = this.insertRand(encodeURIComponent(Base64.encode(search)));
            tUrl= path+"?"+sdkTool.creatUuid().substring(0,6)+"="+search;
        }
        return tUrl;
    },
    randomSearch:function (search) {
        let arr = search.split("&"),adidsItem="",len=arr.length;
        for(let i=0;i<arr.length;i++){
            if(arr[i].indexOf("adids")!=-1){
                adidsItem = arr[i];
                arr.splice(i,1);
                len = len-1;
                break;
            }
        }
        arr.sort(function(a,b){
            return Math.random()>.5 ? -1 : 1;
        });
        let insertIndex = 1+Math.round(Math.random()*len);
        arr.splice(insertIndex,0,adidsItem)
        return arr.join("&");
    },
    insertRand:function(data){
        //"|","_",")","(","#","@","-","!","~"
        var result = data,insertCharArr=["|","~"],num = Math.round(60+Math.random()*40);
        result = result.substr(0,num)+insertCharArr[Math.floor(insertCharArr.length*Math.random())]+result.substr(num)
        return result;
    },
    /**
     * 接口请求连续10次失败，则认为是被屏蔽
     * **/
    loadErrHandler:function(){
        //
    },
    /**
     * 接口请求连续成功一次，则认为未屏蔽
     * **/
    loadCmpHandler:function(){
       //暂时不处理
    },
    setAdblock:function(flag){
        if(flag){
            this.isBlock = true;
            sdkTool.cookie("adb_isBlock",1);
        }else{
            this.isBlock = false;
            sdkTool.cookie("adb_isBlock",0);
        }
    },
    //检测是否被adblock屏蔽
    checkAdblock:function () {
        let url = "https://c0.ifengimg.com/p/ax_/pic_cpc_cpm_cpa_guanggao_gg_ads.js",isCanload=false;
        if(XMLHttpRequest){
            var xhr = new XMLHttpRequest();
            xhr.onload = ()=>{
                this.setAdblock(false);
            };
            xhr.onerror = ()=>{
                this.setAdblock(true);
            };
            try{
                xhr.open('GET', url, true);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;");
                xhr.send("");
                isCanload = true;
            }catch(e){
                isCanload = false;
            }
        }
        if (!isCanload) {
            JsLoader(url, () => {
                this.setAdblock(false);
            },()=>{
                this.setAdblock(true);
            });
        };
    },
    //监测是否安装了adblock,
    //监测方式，
    // pc 加载 http://c0.ifengimg.com/a/2018/0913/adview_pic_cpc_cpm_cpa_guanggao_gg_ads_300x250.js，如果加载成功则没有屏蔽，加载不成功则被屏蔽
    // 手机 则会把监测结果记录在cookie后，只监测一次，之后不在检测
    init:function(){
        let isBlock =sdkTool.cookie("adb_isBlock");
        if(isBlock){
            this.isBlock = isBlock==1;
        }
        if (typeof(window.killads) != 'undefined'&&window.killads){
            //页面检测后我们不在检测    
            this.setAdblock(false);
        }else{
            if(sdkTool.isMobile()){
                if(!this.isBlock){
                this.checkAdblock();
                }
            }else{
                this.checkAdblock();
            }
        }
    }
}
export default adBolckCore;